/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface UserState {
  value: any;
  isLoaded: boolean;
}

const initialState: UserState = {
  value: null,
  isLoaded: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, { payload }) => {
      state.value = payload;
      state.isLoaded = true;
    },

    logoutUser: (state) => {
      state.value = null;
      state.isLoaded = false;
    },
  },
  extraReducers: () => {},
});

export const { setUser, logoutUser } = userSlice.actions;
export const userSelector = (state: RootState) => state.user;
